import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// containers
const DefaultContainer = () => import('./containers/DefaultContainer.vue')
const GameDefaultContainer = () => import('./containers/GameDefaultContainer')
const GameContainer = () => import('./containers/GameContainer.vue')
const ChatContainer = () => import('./containers/ChatContainer.vue')
const ReportContainer = () => import('./containers/ReportContainer')
const MessageContainer = () => import('./containers/MessageContainer')
const MatchMakingContainer = () => import('./containers/MatchMakingContainer')

// dashboard 
const Dashboard = () => import('./views/Dashboard.vue')

//matchmaking
const MatchMaking = () => import('./components/MatchMaking/MatchMaking.vue')
const WaitingRoom = () => import('./views/WaitingRoom.vue')
import CreateTG from './components/MatchMaking/CreateTG.vue'

//rules
import Rules from './components/Rules/Rules.vue'

// game
import GameEnigmas from './views/GameEnigmas.vue'
const FinalEquation = () => import('./views/FinalEquation.vue')

// chat
import ChatInitial from './components/Chat/ChatInitial.vue'
const ChatTeam = () => import('./views/ChatTeam.vue')
const ChatBody = () => import('./components/Chat/ChatBody')

// middleware
// import RedirectAuth from './middleware/RedirectAuth.vue'
const RedirectAuth = () => import('./middleware/RedirectAuth.vue')
const RedirectExternal = () => import('./middleware/RedirectExternal.vue')


// Alerts
const AlertAnswer = () => import('./components/Alerts/AlertAnswer.vue')
const AlertTeamFinish = () => import('./components/Alerts/AlertTeamFinish.vue')
const AlertFinal = () => import('./components/Alerts/AlertFinal')
const AlertCorrect = () => import('./components/Alerts/AlertCorrect')

// feedback
const Feedback360 = () => import('./views/Feedback360.vue')

// message 
const MessageContent = () => import('./components/Message/MessageContent.vue')

//report
const AcceptReport = () => import('./views/AcceptReport')
const ReportMiddleware = () => import('./components/Report/ReportMiddleware.vue')
const ChartRadar = () => import('./components/Report/ChartRadar.vue')
const Competences = () => import('./components/Report/Competences.vue')

//feedback candidato
const AlertFeedback = () => import('./components/Alerts/AlertFeedback')
const FeedbackContainer = () => import('./containers/FeedbackContainer')
const FeedbackExperience = () => import('./views/feedback/FeedbackExperience')
const FeedbackPreference = () => import('./views/feedback/FeedbackPreference')
const FeedbackProblem = () => import('./views/feedback/FeedbackProblem')
const FeedbackExplain = () => import('./views/feedback/FeedbackExplain')
const FeedbackGift = () => import('./views/feedback/FeedbackGift')
const FeedbackFinish = () => import('./views/feedback/FeedbackFinish')
// import FeedbackContainer from './containers/FeedbackContainer'
// import FeedbackExperience from './views/feedback/FeedbackExperience'
// import FeedbackPreference from './views/feedback/FeedbackPreference'
// import FeedbackProblem from './views/feedback/FeedbackProblem'
// import FeedbackExplain from './views/feedback/FeedbackExplain'
// import FeedbackGift from './views/feedback/FeedbackGift'
// import FeedbackFinish from './views/feedback/FeedbackFinish'

const router = new Router({
  mode : 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect : '/dashboard',
      name: 'game-container',
      component: DefaultContainer,
      props: true,
      children : [
        {
          path : 'dashboard',
          name : 'dashboard',
          component : Dashboard,
          props : true
        },
        {
          path : '/feedback360',
          name : 'feedback360',
          component : Feedback360
        },
        {
          path : '/final-game',
          name : 'final-game',
          component : AlertAnswer,
          props : true
        }
      ]
    },
    {
      path: '/match-making',
      name : 'match-making',
      component: MatchMaking
    },
    {
      path : '/waiting-room',
      name : 'waiting-room',
      component : MatchMakingContainer,
      children : [
        {
          path: '/',
          name : 'waiting-room',
          component: WaitingRoom
        },
        {
          path : '/rules',
          name : 'rules',
          component : Rules
        },
        {
          path : '/chat-initial',
          name : 'chat-initial',
          component : ChatInitial
        }
      ]
    },
    {
      path : '/middleware-game',
      name : 'middleware-game',
      component : CreateTG
    },
    {
      path : '/redirect-auth',
      name: 'redirect-auth',
      component: RedirectAuth
    },
    {
      path : '/redirect-external',
      name: 'redirecExternal',
      component: RedirectExternal
    },
    {
      path : '/game',
      name : 'game-container-default',
      component : GameDefaultContainer,
      children : [
        {
          path : '/game',
          name : 'game',
          component : GameContainer,
          children : [
            {
              path : '/',
              name: 'game-enigma',
              component:  GameEnigmas
            },
            {
              path: '/final-equation',
              name : 'final-equation',
              component : FinalEquation
            }
          ]
        },
        {
          path : '/chat-list',
          name: 'chat-list',
          component: ChatContainer,
          children : [
            {
              path : '/chat-list',
              name: 'chat-list',
              component: ChatTeam,
            },
            {
              path : '/chat/:letter',
              name : 'chat',
              component: ChatInitial
            }
          ]
        },
      ]
    },
    {
      path : '/correct-alert',
      name : 'correct-alert',
      component : AlertCorrect
    },
    {
      path : '/final-team',
      name : 'final-team',
      component : AlertTeamFinish,
      props : true
    },
    {
      path : '/final-alert',
      name : 'final-alert',
      component : AlertFinal
    },
    {
      path : '/middleware-report',
      name : 'middleware-report',
      component : ReportMiddleware
    },
    {
      path : '/report',
      name : 'report',
      component : ReportContainer,
      children : [
        {
          path : 'graphic',
          name : 'graphic',
          component : ChartRadar
        },
        {
          path : 'skills',
          name : 'skills',
          component : Competences
        },
        {
          path : '/feedback-alert',
          name : 'feedback-alert',
          component : AlertFeedback
        }
      ]
    },
    {
      path : '/message',
      name : 'message',
      component : MessageContainer,
      children : [
        {
          path : '/message/:id',
          name : 'message-id',
          component : MessageContent
        }
      ]
    },
    {
      path : '/accept-report/:id',
      name : 'accept-report',
      component : AcceptReport
    },
    {
      path : '/feedback',
      name : 'Feedback',
      component : FeedbackContainer,
      children : [
          {
              path : '/feedback-experience',
              name : 'Feedback Experience',
              component : FeedbackExperience,
          },
          {
              path : '/feedback-preference',
              name : 'Feedback Preference',
              component : FeedbackPreference,
          },
          {
              path : '/feedback-problem',
              name : 'Feedback Problem',
              component : FeedbackProblem,
          },
          {
              path : '/feedback-explain',
              name : 'Feedback Explain',
              component : FeedbackExplain,
          },
          {
              path : '/feedback-gift',
              name : 'Feedback Gift',
              component : FeedbackGift,
          }
      ]
    },
    {
        path : '/feedback-finish',
        name : 'Feedback Finish',
        component : FeedbackFinish,
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(from.name == 'game-enigma' && to.name == 'middleware-game'){
    return router.push({ name: 'game-enigma' })
  }
  if(from.name == 'game-enigma' && to.name == 'rules'){
    return router.push({ name: 'game-enigma' })
  }
  if(from.name == 'game-enigma' && to.name == 'dashboard'){
    return router.push({ name: 'game-enigma' })
  }
  next()
});

export default router;
